module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_8003.8d238cb2.png";